import CardWrapper from "../../HOC/card/card";
import SectionTitle from "../../components/section-title";
import StatisticsChart from "../../components/statistics-chart";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";
const gainerTypes = [
  {
    label: "ذكر",
    innerRadius: 0.5,
    angle: 10048,
    style: { fill: "#5baf61", stroke: "#5baf61" },
  },
  {
    label: "أنثى",
    innerRadius: 0.5,
    angle: 3000,
    style: { fill: "#7460c0", stroke: "#7460c0" },
  },
];
const gainerTypes2 = [
  {
    label: "شباب وفتيات",
    innerRadius: 0.5,
    angle: 10048,
    style: { fill: "#5b3f61", stroke: "#5b3f61" },
  },
  {
    label: "أطفال",
    innerRadius: 0.5,
    angle: 3000,
    style: { fill: "#a562c0", stroke: "#a562c0" },
  },
  {
    label: "أيتام",
    innerRadius: 0.5,
    angle: 10048,
    style: { fill: "#5abf61", stroke: "#5abf61" },
  },
  {
    label: "جاليات",
    innerRadius: 0.5,
    angle: 3000,
    style: { fill: "#ca60c0", stroke: "#ca60c0" },
  },
  {
    label: "كبار السن",
    innerRadius: 0.5,
    angle: 10048,
    style: { fill: "#db4f61", stroke: "#db4f61" },
  },
  {
    label: "المقبلين على الزواج",
    innerRadius: 0.5,
    angle: 3000,
    style: { fill: "#7450c0", stroke: "#7450c0" },
  },
  {
    label: "ذوو احتياجات خاصة",
    innerRadius: 0.5,
    angle: 10048,
    style: { fill: "#5aff61", stroke: "#5aff61" },
  },
  {
    label: "عام",
    innerRadius: 0.5,
    angle: 3000,
    style: { fill: "#74b0c0", stroke: "#74b0c0" },
  },
  {
    label: "غير ذلك",
    innerRadius: 0.5,
    angle: 3000,
    style: { fill: "#cff0c0", stroke: "#cff0c0" },
  },
];
const StatisticsPage1 = ({ handleChangePage }) => {
  return(
    <Row className="statistics-row-container" gutter={16}>
    <Col className="gutter-row arrows-container" xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
    
    
      <CardWrapper>
        <SectionTitle title="عدد المستفيدين" />
        <div className="gainer-num">
          <h3>إجمالي عدد المستفيدين</h3>
          <span>13,048</span>
        </div>
      </CardWrapper>
      <CardWrapper classes="gainer-types">
        <SectionTitle title="نوع المستفيدين" />
        <StatisticsChart data={gainerTypes} />
      </CardWrapper>
      <div className="stat-arrows-container">
        <RightOutlined
          className="stat-arrows stat-right-arrow"
          style={{color:'gray'}}
        />
        <LeftOutlined
          onClick={() => handleChangePage(1)}
          className="stat-arrows stat-left-arrow"
        />
      </div>
    </Col>
    <Col className="gutter-row" xxl={16} xl={16} lg={16} md={24} sm={24} xs={24}>
      <CardWrapper classes="gainer-types mt-0">
        <SectionTitle title="فئة المستفيدين" />
        <StatisticsChart data={gainerTypes2} />
      </CardWrapper>
    </Col>
  </Row>
  )
};
export default StatisticsPage1;
